import { ComponentChild, FunctionalComponent, h } from "preact";
import { useEffect } from "preact/hooks";
import { MessageFrame } from "../../components/messageFrame";
import {
  IcoDownload,
  IcoFile,
  IcoPlayCircle,
  IcoQuestionCircle,
} from "../../components/icons";
import "../../style/attachment.scss";
import { polyfill } from "smoothscroll-polyfill";
import {log} from "../../libs/QuerloLogger";

const FileAttachment: FunctionalComponent<{
  fileName: string;
  assetsBaseURL: string;
  mimeType: string;
  time: string;
  msgID: string;
  disableEffects?: number[];
  lightboxCallback: (content: ComponentChild) => void;
  tickCallback: () => void;
}> = ({
  fileName,
  assetsBaseURL,
  mimeType,
  time,
  msgID,
  disableEffects,
  lightboxCallback,
  tickCallback,
}) => {
  useEffect(() => {
    /** advance queue */
    tickCallback();
  }, [msgID]);

  const isImg = mimeType.indexOf("image") !== -1;
  const isVideo = mimeType.indexOf("video") !== -1;
  const isApplication = mimeType.indexOf("application") !== -1;
  const isUnknown = !isImg && !isVideo && !isApplication;
  const completeURL = `${assetsBaseURL}image_uploads/ht/${fileName}`;
  const fileType = mimeType.split("/")[1];
  log.debug(fileType, mimeType);
  const lightboxData = {
    node: (
      <div class="lightboxWrp">
        {isImg && <img className="img" src={completeURL} />}
        {isVideo && (
          <video alt="attached video" controls>
            <source src={completeURL} type={mimeType} />
          </video>
        )}
      </div>
    ),
  };

  return (
    <MessageFrame clsName="attachmentWrp" name={name} time={time}>
      {isImg && (
        <div
          className="imgWrp"
          onClick={(): void => lightboxCallback(lightboxData)}
        >
          <img src={completeURL} />
        </div>
      )}
      {isVideo && (
        <div
          className="videoWrp"
          onClick={(): void => lightboxCallback(lightboxData)}
        >
          <video alt="attached video">
            <source src={completeURL} type={mimeType} />
          </video>
          <div className="play">
            <IcoPlayCircle />
          </div>
        </div>
      )}
      {(isApplication || isUnknown) && (
        <div className="fileWrp">
          <a href={completeURL} target="_blank" rel="noreferrer">
            <div className="default">
              {isUnknown && <IcoQuestionCircle />}
              {!isUnknown && <IcoFile />}
            </div>
            <div className="hover">
              <IcoDownload />
            </div>
            <div className="fileName">document</div>
          </a>
        </div>
      )}
    </MessageFrame>
  );
};

export default FileAttachment;
